import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import { AssociationCategoryTypesToIds } from 'customer-data-objects/associations/AssociationCategoryTypes';
const useDefaultCardFooterAction = args => {
  const {
    associationDefinition,
    fromObjectId,
    objectTypeDefinition,
    toObjectTypeId,
    total,
    usageTracker,
    currentSearchQuery
  } = args;
  const href = useMemo(() => {
    const portalId = PortalIdParser.get();
    const associationCategoryNumber = AssociationCategoryTypesToIds[associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.category];
    const filters = encodeURIComponent(JSON.stringify([{
      operator: 'EQ',
      value: fromObjectId,
      property: `associations.${associationCategoryNumber}-${associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.inverseId}`
    }]));
    return `/contacts/${portalId}/objects/${toObjectTypeId}/views/all/list?filters=${filters}`;
  }, [associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.category, associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.inverseId, fromObjectId, toObjectTypeId]);
  const viewAllObjectsLabel = I18n.text('cardAssociatedObjects.AssociatedObjectsCardPaginator.viewAllAssociated', {
    count: total || 0,
    associationToPlural: (objectTypeDefinition === null || objectTypeDefinition === void 0 ? void 0 : objectTypeDefinition.pluralForm) || toObjectTypeId
  });
  const handleTracking = () => {
    usageTracker === null || usageTracker === void 0 || usageTracker.track('sidebar-interaction', {
      type: toObjectTypeId,
      action: 'view all associated objects'
    });
  };
  const hasAssociations = total && total > 0;
  const hasActiveSearchTerm = currentSearchQuery !== '';
  const shouldShowViewAllObjects = hasAssociations || hasActiveSearchTerm;
  return {
    primaryActionConfig: shouldShowViewAllObjects ? {
      label: viewAllObjectsLabel,
      href,
      onClick: handleTracking,
      external: true
    } : null
  };
};
export default useDefaultCardFooterAction;